export const useScrollDirection = (direction: "horizontal" | "vertical") => {
  const state = {
    start_position: { x: 0, y: 0 },
    direction: null,
  };

  const getTouchCoords = (e: TouchEvent) => ({
    x: e.touches[0]?.clientX ?? 0,
    y: e.touches[0]?.clientY ?? 0,
  });

  const handleTouchStart = (e: TouchEvent) => {
    const coords = getTouchCoords(e);

    state.start_position.x = coords.x;
    state.start_position.y = coords.y;
  };

  const handleTouchMove = (e: TouchEvent) => {
    if (!state.start_position.x || !state.start_position.y) return;
    if (state.direction === direction) {
      e.stopPropagation();
      return;
    }

    const coords = getTouchCoords(e);
    const delta_x = Math.abs(coords.x - state.start_position.x);
    const delta_y = Math.abs(coords.y - state.start_position.y);

    state.direction = delta_y > delta_x ? "vertical" : "horizontal";

    if (state.direction === direction) e.stopPropagation();
  };

  const handleTouchEnd = (e: TouchEvent) => {
    if (state.direction === direction) {
      e.stopPropagation();
    }

    state.start_position.x = 0;
    state.start_position.y = 0;
    state.direction = null;
  };

  return {
    start: handleTouchStart,
    move: handleTouchMove,
    end: handleTouchEnd,
  };
};
